import { z } from 'zod';

export const claimEnglishIqV1RequestSchema = z.object({
  handoffToken: z.string().min(1),
});

export type IClaimEnglishIqV1Request = z.infer<typeof claimEnglishIqV1RequestSchema>;
